module.exports = __webpack_public_path__ + "media/honey-icons/icon-microphone-d0a49d3f.svg";